module.exports = __webpack_public_path__ + "assets/febf64fd7d30fe42bf38fc6601dbe2f0.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/win/Level2_Hit06s.mp3
 ** module id = 335
 ** module chunks = 0
 **/